module.exports = __webpack_public_path__ + "static/crab_leg-6816369b5fbc6b612b77691e467cd833.png";